// extracted by mini-css-extract-plugin
export default {"nopage_box":"_404_nopage_box__CiDiV","nopage_text":"_404_nopage_text__3S2BG","nopage_link":"_404_nopage_link__Bl4J6"};